import axios from 'axios'

// 查询违章记录（新接口）
export function findCarBreakrule(data) {
    return axios({
        method: 'post',
        url: '/user/smartCarBreakrule/findCarBreakrule',
        data: data,
        headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    })
}

// 旧的超速查询接口（保留备用）
export function findCarBreakruleNew(data) {
    return axios({
        method: 'get',
        url: '/user/samrtCarSpeed/findPageNew',
        params: data,
        headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    })
}

// 获取违章类型（保留备用）
export function getBreakType(data) {
    return axios({
        method: 'get',
        url: '/user/common/getParamater?paratype=' + data,
        headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    })
}

// 按车牌号查询（保留备用）
export function findCarByCarOn(carOn, data) {
    return axios({
        method: 'get',
        url: '/user/samrtCarSpeed/' + carOn,
        params: data,
        headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    })
}
